import React from "react";

import { format } from "date-fns";
import { keys } from "ramda";
import { Label, ReferenceLine } from "recharts";
import { getFrontDate } from "root/utils/date";
import { socialNetworksLogos } from "root/utils/socialNetworks";

// ------------------------------------------------------------------------
export const socialNetworkReferenceLines = (
  socialNetworks = [],
  setHoverMark = () => {},
  styles,
  yAxisId,
  onServerFormat,
  data = [],
  onClick = () => {}
) => {
  return socialNetworks.map(item => {
    const foundItem = data.find(i => i.date === item.date || i.date === getFrontDate(item.date));
    const itemData = foundItem?.ea_ads || foundItem?.product_bs || {};
    const date = onServerFormat
      ? format(new Date(item.date), "yyyy-MM-dd")
      : format(new Date(item.date), "dd.MM.yyyy");
    const { value = {} } = item;
    return (
      <ReferenceLine key={date} x={date} stroke="purple" yAxisId={yAxisId} index={date}>
        {keys(value).map((socialItem, index) => {
          const src = socialNetworksLogos[socialItem].default || "";
          const targetLine = document.querySelector(`line[x="${date}"]`);
          return (
            <Label
              value={item}
              content={props =>
                renderCustomLabel({
                  onClick: () => onClick({ ...itemData[socialItem], date, source: socialItem }),
                  onMouseLeave: () => setHoverMark(),
                  onMouseEnter: () =>
                    setHoverMark({
                      date,
                      item: socialItem,
                      count: value?.[socialItem] ?? 0,
                      data: itemData,
                    }),
                  y: (index + 1) * 25,
                  x: 7,
                  src,
                  ...props,
                })
              }
              key={socialItem}
              position="insideTopRight"
              fontSize={28}
              dx={13.5}
              style={targetLine ? {} : { webkitTextSecurity: "square" }}
              className={styles.label}
              dy={(index + 1) * 25}
            />
          );
        })}
      </ReferenceLine>
    );
  });
};

//
const labelWidth = 14;
const labelHeight = 14;
//
const renderCustomLabel = ({ onMouseLeave, onMouseEnter, viewBox, src, y, onClick }) => {
  return (
    <foreignObject
      {...{ onMouseLeave, onMouseEnter, y }}
      style={{
        cursor: "pointer",
      }}
      x={viewBox.x - labelWidth / 2}
      width={labelWidth}
      height={labelHeight}>
      <img
        src={src}
        style={{ width: labelWidth, height: labelHeight, objectFit: "contain" }}
        alt="Photo"
        onClick={onClick}
      />
    </foreignObject>
  );
};

// export default SocialNetworkReferenceLines;
